import Vue from 'vue'
import HttpRequest from './http'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'


Vue.use(HttpRequest)
Vue.use(WechatPlugin)

export default {
install (Vue, options) {

Vue.isWechat = function () {
let ua = navigator.userAgent.toLowerCase()
return /micromessenger/.test(ua)
}


Vue.wechatHideShare = function (url) {
Vue.post('sys/wxJsApi', {
url: url || window.location.href
}, (res) => {
if (res.code === 200 && res.data) {
let req = {
debug: false,
appId: 'wxf2e9e632dec9e36c',
nonceStr: res.data.noncestr,
timestamp: res.data.timestamp,
signature: res.data.signature,
jsApiList: ['hideMenuItems']
}
Vue.wechat.config(req)
Vue.wechat.error((res) => {})
Vue.wechat.ready(() => {
Vue.wechat.hideMenuItems({
menuList: [
'menuItem:share:appMessage',
'menuItem:share:timeline',
'menuItem:share:qq',
'menuItem:share:QZone'
]
})
})
}
})
}


Vue.wechatShare = function (url, link, title, desc, image) {
if (!image) {
image = window.location.protocol + '//' +
window.location.host + '/shixing/static/img/logo.jpg'
}
Vue.post('sys/wxJsApi', {
url: url || window.location.href
}, (res) => {
if (res.code === 200 && res.data) {
let req = {
debug: false,
appId: 'wxf2e9e632dec9e36c',
nonceStr: res.data.noncestr,
timestamp: res.data.timestamp,
signature: res.data.signature,
jsApiList: ['showMenuItems',
'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ']
}
Vue.wechat.config(req)
Vue.wechat.error((res) => {})
Vue.wechat.ready(() => {
Vue.wechat.showMenuItems({
menuList: [
'menuItem:share:appMessage',
'menuItem:share:timeline',
'menuItem:share:qq',
'menuItem:share:QZone'
]
})

Vue.wechat.onMenuShareTimeline({
title: title,
link: link,
imgUrl: image
})

Vue.wechat.onMenuShareAppMessage({
title: title,
desc: desc,
link: link,
imgUrl: image
})

Vue.wechat.onMenuShareQQ({
title: title,
desc: desc,
link: link,
imgUrl: image
})

Vue.wechat.onMenuShareQZone({
title: title,
desc: desc,
link: link,
imgUrl: image
})
})
}
})
}

Vue.prototype.$isWechat = () => {
return Vue.isWechat()
}

Vue.prototype.$wechatShare = (url, link, title, desc, image) => {
Vue.wechatShare(url, link, title, desc, image)
}

Vue.prototype.$wechatHideShare = (url) => {
Vue.wechatHideShare(url)
}
}
}



// WEBPACK FOOTER //
// ./src/plugins/wechat.js